import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// import { NgReduxModule } from '@angular-redux/store';
// import { ClickOutsideModule } from 'ng-click-outside';

import { SystemMessagesService } from './system-messages/system-messages.service';

import { EquelValueValidatorDirective } from './validators/equel-value-validator.directive';

import { SystemMessagePipe } from './pipes/system-messages.pipe';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pluck';
import { IframePostmessagesService } from './iframe-postmessages/iframe-postmessages.service';
import { ElasticLogService } from './elastic-log/elastic-log.service';
import { TzValidatorDirective } from './validators/tz-validator.directive';
import { GaManagerDirective } from './directives/ga-manager.directive';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    // NgReduxModule,
    /*ClickOutsideModule*/
  ],
  exports:
    [CommonModule,
      HttpClientModule,
      /*ClickOutsideModule,*/
      EquelValueValidatorDirective,
      TzValidatorDirective,
      SystemMessagePipe,
      GaManagerDirective,
      NumbersOnlyDirective
    ],
  declarations: [
    EquelValueValidatorDirective,
    TzValidatorDirective,
    SystemMessagePipe,
    GaManagerDirective,
    NumbersOnlyDirective
  ],
  providers: [
    SystemMessagesService,
    IframePostmessagesService,
    ElasticLogService
  ]
})
export class HarelCommonModule { }
